export const OLD_PARTNER_CONFIG_URL = 'partner-config';
export const BACK_TO_PARTNER_ROUTE_PARAM = 'backToPartner';
export const BACK_TO_FILTER_ROUTE_PARAM = 'backToFilter';
export const OPEN_USER_CONFIGURATION_MODAL = 'openUserConfiguration';

export const FAQ_LINKS = {
    faqLink: 'https://support.singular.net/hc/en-us/articles/115000483946-Partner-Configuration-FAQ',
};
export const FACEBOOK_PARTNER_NAME = 'facebook';
export const TIKTOK_PARTNER_NAME = 'tiktok_san';
export const SNAPCHAT_PARTNER_NAME = 'snapchat';
export const APPLE_SEARCH_ADS_PARTNER_NAME = 'applesearchads_adservices';
export const GOOGLE_ADWORDS_PARTNER_NAME = 'adwords';
export const UBER_ADS_PARTNER_NAME = 'Uber Ads';
export const ROKU_PARTNER_NAME = 'roku';
export const TENCENT_PARTNER_NAME = 'tencent';
export const GOOGLE_ADS_OFFLINE_CONVERSIONS_PARTNER_NAME = 'google-ads-offline-conversions-api-s2s';
export const GOOGLE_ADS_ENHANCED_CONVERSIONS_PARTNER_NAME = 'google-ads-enhanced-conversions-api-s2s';
export const GOOGLE_ADS_WEB_PARTNER_NAME = 'google-ads-web';
export const SNAP_CONVERSIONS_PARTNER_NAME = 'snap-conversions-api-s2s';
export const MICROSOFT_ADS_CONVERSIONS_PARTNER_NAME = 'microsoft-ads-conversions-api-s2s';
export const TWITTER_PARTNER_NAME = 'twitter';

const AMAZON_PARTNER_NAME = 'amazonads';
const YAHOO_GEMINI_PARTNER_NAME = 'yahoogemini';
const YAHOO_JAPAN_PARTNER_NAME = 'yahoo_japan_sponsored_search';
export const HOTSTAR_NAME = 'HotStar';
// When adding a new SAN partner to this list, you must also:
// 1. Add the base_source name value to SELF_ATTRIBUTED_NETWORKS_NAMES in agency_utils.py
// 2. Create a migration to update existing agency row permissions in the DB
//    (see migrations/1482_remove_roku_from_agency_permissions.py for reference)
export const SAN_PARTNERS = [
    FACEBOOK_PARTNER_NAME,
    TIKTOK_PARTNER_NAME,
    SNAPCHAT_PARTNER_NAME,
    AMAZON_PARTNER_NAME,
    YAHOO_GEMINI_PARTNER_NAME,
    APPLE_SEARCH_ADS_PARTNER_NAME,
    GOOGLE_ADWORDS_PARTNER_NAME,
    YAHOO_JAPAN_PARTNER_NAME,
    UBER_ADS_PARTNER_NAME,
    ROKU_PARTNER_NAME,
    TWITTER_PARTNER_NAME,
];

export const EULA_PARTNERS = [SNAPCHAT_PARTNER_NAME, TWITTER_PARTNER_NAME];
export const eulasTitleKey = name => `STATIC.PAGES.PARTNER_CONFIGURATION.EULAS.${name.toUpperCase()}_HEADER`;
export const eulasMessageKey = name => `STATIC.PAGES.PARTNER_CONFIGURATION.EULAS.${name.toUpperCase()}_DESCRIPTION`;

export const APP_AUTOCOMPLETE_PLACEHOLDER_MESSAGES = {
    noIntegratedApps: 'STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.NO_INTEGRATED_APPS',
    selectApp: 'STATIC.PLACEHOLDERS.SELECT_APP',
};
